import React, { useContext, useState, useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { AppContext } from '../../contexts/AppContext';
import * as TestimonialText from './TestimonialText';

function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export default function Testimonials() {
  const { useMobileView } = useContext(AppContext);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [nextIndex, setNextIndex] = useState(1);
  const [delay, setDelay] = useState(10000);

  useInterval(() => {
    setCurrentIndex(nextIndex); 
    setNextIndex(nextIndex + 1); 
  }, delay);

  useEffect(() => {
    if (nextIndex >= TestimonialText.testimonials.length) {
      setNextIndex(0);
    }
  }, [nextIndex]);

  useEffect(() => {
    setDelay(TestimonialText.testimonials[currentIndex].interval);
  }, [currentIndex]);

  return (
      <Grid
        container
        spacing={2}
        sx={{
          minHeight: useMobileView ? '300px' : '350px',
          borderTop: '2px solid white',
          borderBottom: '2px solid white',
          borderLeft: !useMobileView ? '2px solid white': 'none',
          borderRight: !useMobileView ? '2px solid white': 'none',
          borderRadius: !useMobileView ? '4px' : '0px',
        }}
      >
        <Grid
          item
          xs={12}
          container
          justifyContent="center"
          alignItems="center"
          sx={{
            paddingRight: '16px',
            paddingBottom: '16px',
          }}
        >
          {useMobileView ? (
            <Typography
              sx={{
                textAlign: 'center',
                fontFamily: TestimonialText.testimonials[currentIndex].fontStyle,
                fontSize: '16px',
              }}
            >
              {`"${TestimonialText.testimonials[currentIndex].text}"`}
            </Typography>
          ): (
            <>
              <Typography
                sx={{
                  textAlign: 'center',
                  fontFamily: TestimonialText.testimonials[currentIndex].fontStyle,
                  fontSize: TestimonialText.testimonials[currentIndex].fontSize,
                  fontWeight: TestimonialText.testimonials[currentIndex].fontWeight,
                }}
              >
                {`"${TestimonialText.testimonials[currentIndex].text}"`}
              </Typography>
            </>
          )}
        </Grid>
        <Grid item xs={12} container justifyContent="flex-end" alignItems="flex-end" sx={{paddingRight: '16px'}}>
          <Typography sx={{ fontStyle: 'italic' }}>
            -Creator Feedback
          </Typography>
        </Grid>
      </Grid>
  );
}
